<template>
  <el-dialog title="业务备注" :visible.sync="dialogVisible" width="600" custom-class="dialog-title-left">
    <div style="min-height: 100px">{{ remark  || '暂无信息'}}</div>
  </el-dialog>
</template>
<script>
export default {
  name: 'remarkDialog',
  data(){
    return {
      remark: '',
      dialogVisible: false
    }
  },
  methods:{
    open(remark){
      this.remark = remark
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="less">
.dialog-title-left {
  .el-dialog__header {
    .el-dialog__title {
      margin-left: 20px;
    }
  }
}
</style>